export default __webpack_public_path__ + "static/media/MIPS-Bali-2019-Event-Pic.537cc34d.png";